import { makeRequest } from 'utils/requestLogger';

export default (id, roundtable_id) =>
    makeRequest('post', `/api/recaps/${id}/roundtable/${roundtable_id}/summarize-submissions`);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/genieRecapSummarizeSubmissions.js